/**
 * AI düğmesi — sağ altta duran yüzen düğme.
 *
 * Yalnızca yetki + sunucu hazırsa çiziliyor (bkz. useAiAccess). Panel açıkken düğme
 * kayboluyor: mobilde panel tam ekran ve düğme onun üstünde asılı kalıyordu.
 *
 * Klavye kısayolu ⌘/Ctrl+J — sohbeti açmak için fareye uzanmak gerekmesin.
 */
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

export function AiChatFab({ hidden, onClick }: { hidden: boolean; onClick: () => void }) {
  const { t } = useTranslation();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'j') {
        e.preventDefault();
        onClick();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClick]);

  if (hidden) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t('ai.openPanel')}
      title={`${t('ai.openPanel')} (⌘/Ctrl+J)`}
      data-testid="ai-fab"
      className={cn(
        'fixed right-4 bottom-4 z-30 inline-flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition-transform',
        'bg-gradient-to-br from-[var(--brand-gradient-from)] to-[var(--brand-gradient-to)]',
        'hover:scale-105 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none active:scale-95',
        // Mobilde alt güvenli alanın üstünde dursun.
        'mb-[env(safe-area-inset-bottom,0px)]',
      )}
    >
      <Sparkles className="h-5 w-5" />
    </button>
  );
}
